import React, { FC } from "react";
import { Outlet, useParams } from "react-router-dom";
import { GIS_NO_ORDER_UID } from "@app/utils/gisEntrySource";
import { getGisIntakeFormStateCacheKey, IntakeFormProvider } from "./context";

/**
 * Layout for GIS patient-education, scheduling, and intake routes.
 * Scopes IntakeFormProvider state per order + test so a second intake for another
 * test does not reuse the previous session's cached answers or prefill context.
 */
const OncUppGisTriageLayout: FC = () => {
  const { orderUidPublic, testUid } = useParams<{
    orderUidPublic: string;
    testUid: string;
  }>();

  const stateCacheKey = getGisIntakeFormStateCacheKey(orderUidPublic, testUid);
  const isNoOrder = orderUidPublic === GIS_NO_ORDER_UID;

  return (
    <IntakeFormProvider
      key={stateCacheKey}
      stateCacheKey={stateCacheKey}
      isNoOrder={isNoOrder}
    >
      <Outlet />
    </IntakeFormProvider>
  );
};

export default OncUppGisTriageLayout;
